import React from "react";
import { Tooltip } from "@mui/material";
import { Wrapper } from "./styled";

const Description = ({ row }) => {
  if (!row.isExpanded || row.original.articleDescription === "") {
    return null;
  }

  return (
    <Tooltip title={row.original.articleDescription}>
      <Wrapper>{row.original.articleDescription}</Wrapper>
    </Tooltip>
  );
};

export default Description;
